import ElementPlus, { ID_INJECTION_KEY } from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

export default defineNuxtPlugin((nuxtApp) => {
  // prefix 를 고정값으로 설정: Math.random() 은 SSR 과 클라이언트가
  // 서로 다른 값을 생성해 hydration 불일치 → el-popper-container ID 충돌
  // → 드롭다운 팝업 포지셔닝 오작동의 원인이 되므로 고정값 사용.
  nuxtApp.vueApp.provide(ID_INJECTION_KEY, {
    prefix: 1000,
    current: 0,
  })
  nuxtApp.vueApp.use(ElementPlus)
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    nuxtApp.vueApp.component(key, component)
  }
})
